




























import { Vue, Component, Prop } from 'vue-property-decorator'
import { ElementMixin, HandleDirective } from 'vue-slicksort';
import * as Y from 'yjs'
import Delta from 'quill-delta'
import MarkdownEditorCrdt from 'components/MarkdownEditorCrdt.vue'

@Component({
  components: {
    MarkdownEditorCrdt
  },
  mixins: [ ElementMixin ],
  directives: {
    handle: HandleDirective
  }
})
export default class ItemTopicSlidesEditorAnswersEditorSortableListItem extends Vue {

  @Prop()
  readonly reorder!: boolean

  @Prop()
  readonly answer!: Json

  get text (): Y.Doc {
    return this.answer.text || new Y.Doc()
  }

  updateText (delta: Delta) {
    this.text.transact(() => {
      this.text.getText().applyDelta(delta.ops)
    }, 'SLIDE_ANSWER_EDIT')
  }
}
